<template>
	<div>
		<div
			v-b-toggle="'collapse-' + id"
			:data-cta="cta"
			class="text-18 text-gotham-bold d-flex justify-content-between"
			@click="onClick"
		>
			<div>
				{{ title }}
			</div>
			<div style="display:flex;align-items:center;">
				<img v-if="!open" alt="up" src="@/assets/images/ic-arrow-up.png" style="width:20px" />
				<img v-else alt="down" src="@/assets/images/ic-arrow-down.png" style="width:20px" />
			</div>
		</div>
		<b-collapse :id="'collapse-' + id" :visible="visible" class="mt-4">
			<slot />
		</b-collapse>
	</div>
</template>

<script>
export default {
	props: {
		open: Boolean,
		title: {
			type: String,
			default: 'Title',
		},
		id: {
			type: String,
			default: 'default',
		},
		visible: Boolean,
		cta: {
			type: String,
			default: 'collapsible_toggle',
		},
	},

	methods: {
		onClick() {
			this.$emit('onClick');
		},
	},
};
</script>

<style scoped></style>
